<template lang='pug'>
div
  v-card-title
    v-toolbar-title.subheading(style="color: grey")
    span.pr-2
    v-text-field(
      v-model="search",
      append-icon="mdi-magnify",
      label="Search",
      single-line,
      hide-details
    )
  v-data-table.elevation-1(
    :headers="ip.headers"
    :sort-desc.sync="ip.ipDateFormat"
    :items="ip.items"
    item-key="itemKey"
    :search='search'
    :page.sync="page"
    :options.sync="options"
    :server-items-length="ip.jumlah"
    :loading="loading"
    loading-text="Loading... Please wait"
    multi-sortBy
    :footer-props="{'items-per-page-options':[5, 10, 15]}"
    :items-per-page="10"
  )
    template(v-slot:item.actions="{ item }")
      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.printView.dialog = true; getPreview(item._id);"
      ) print
      PrintEwaskatPDF(
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="printView"
        typeWaskat="submissionWaskat"
      )
</template>

<script>
import axios from "axios";
import * as config from "../config/index.json";
import { mapState } from "vuex";
import helper from "../helper/index.js";
import PrintEwaskatPDF from "@/components/PrintEwaskatPDF.vue";
export default {
  name: "PrintEwaskatList",
  components: {
    PrintEwaskatPDF,
  },
  props: {
    title: String,
    ip: Object,
  },
  data() {
    return {
      search: "",
      config: config.default,
      pagination: {
        sortBy: ["ipDate"],
        descending: [true],
      },
      options:{
        sortBy: ['ipDate'],
        sortDesc: [true]
      },
      loading: false,
      request:null,
      page: 1,
      itemsPerPage: 10,
      itemView: {},
    };
  },
  beforeDestroy(){
    this.$store.state.printEwaskatList.data = [];
    this.$store.state.printEwaskatList.totalData = 0
  },
  computed: {
    ...mapState([
      "dataUsers",
      "API_URL",
    ]),
  },
  methods: {
    getWITADate: helper.getWITADate,
    cancel(){
      this.request.cancel()
    },
    getOptions() {
      clearTimeout(this._timerId)
      if(this.request) this.cancel();

      this._timerId = setTimeout(()=>{
        this.$store.state.printEwaskatList.data = [];
        this.loading = true;

        if ( this.options.page == undefined ) {
          this.options.page = 1
        }

        if ( this.options.rowsPerPage == undefined ) {
          this.options.rowsPerPage = this.itemsPerPage
        }
        
        const axiosSource = axios.CancelToken.source()
        this.request = {cancel:axiosSource.cancel}
        
        if (this.options.sortBy) {
          const direction = this.options.sortDesc[0] ? 'desc' : 'asc';
          let sortBy = this.options.sortBy;

          if (sortBy[0] == "ipDateFormat") {
            sortBy = ["ipDate"];
          } else if ( sortBy[0] == "ipFormShortName" ) {
            sortBy = ["ipForm"]
          }

          axios.get(
            `${this.$store.state.API_URL}/v1/requests/listPrintEwaskat`, 
            {
              params: {
                email: this.$store.state.dataUsers.email,
                searchQuery: this.search,
                sortBy: sortBy[0],
                order: direction,
                page: this.options.page,
                perPage: this.options.rowsPerPage
              },
              headers: {"Authorization": `Bearer ${this.$store.state.token}`}
            }
          ).then(res => {
            this.page = this.options.page
            this.$store.state.printEwaskatList.data = res.data.data;
            this.$store.state.printEwaskatList.jumlah = res.data.totalData;
            this.request=null
            this.$store.state.loader = false;
          })
          .catch(err => {
            console.log(err)
            this.$store.state.loader = false;
            this.$snackbar.showMessage({ message: err.response.data.message, color: 'red' });
          })
          .finally(() => {
            this.loading = false
            this.$store.state.loader = false;
          });
        }
      },500)
    },
    getPreview(id) {
        axios.get(
          `${this.$store.state.API_URL}/v1/requests/printById/` + id, 
          {
            headers: {"Authorization": `Bearer ${this.$store.state.token}`}
          }
        ).then(res => {
          this.itemView = res.data
          this.$store.state.loader = false;
        })
        .catch(err => {
          console.log(err)
          this.$store.state.loader = false;
        })
        .finally(() => {
          this.$store.state.loader = false;
        });
    },
  },
  watch: {
    options(val){
      this.itemsPerPage = val.itemsPerPage
      this.getOptions()
    },
    search() {
      this.getOptions()
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>